import { parseRichText } from '@griply/utils';
import React, { useMemo } from 'react';
import { LinkBaseProps } from 'shared/components/ui/url-parser';

import * as Styled from './rich-text.style';
import { RichTextNodes } from './rich-text-nodes';

export type RichTextProps = {
  // provider markup; anything outside the modelled subset is unwrapped to its text
  value: string;
  linkComponent?: React.ComponentType<LinkBaseProps>;
  className?: string;
};

export const RichText: React.FC<RichTextProps> = ({
  value,
  linkComponent,
  className,
}) => {
  const nodes = useMemo(() => parseRichText(value), [value]);

  return (
    <Styled.Container className={className}>
      <RichTextNodes nodes={nodes} linkComponent={linkComponent} />
    </Styled.Container>
  );
};
